const showMessage = false;

export const handleRequest = (request) => {
  if (showMessage) {
    console.log(
      '----------------------------------------------------------------------------------------------------------------------------'
    );
    console.log('\tRequest is: ', request);
    // console.log("\turl: %c" + request.url, 'color: blue');
    console.log('\tdata: ', request.data);
    console.log('\tmethod: %c' + request.method.toUpperCase(), 'color: blue');
    console.log('\turl: %c' + request.url, 'color: blue');
    console.log(
      '\t%c--->>  --->>  --->>  --->>  --->>  --->>  --->>  --->>  --->>  --->>',
      'background:blue; color:white'
    );
    // console.log("status: %c" + request.status, 'color: green' );
    // console.log("-------------------------------------------------------");
  }
};

export const handleApiError = (err) => {
  if (showMessage) {
    const { response } = err;
    const { data } = response;
    console.log(
      '\t%c<<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---',
      'background:red; color:white'
    );
    console.log('\turl: %c' + data.url, 'color: red');
    console.log('\tstatus: %c' + response.status, 'color: red');
    console.log('\tstatusText: ' + response.statusText);
    if (data.name) console.log('\tnombre: %c' + data.name, 'color:red');
    if (data.message) console.log('\tmessage: %c' + data.message, 'color:red');
    if (data.errmsg) console.log('\terrmsg: %c' + data.errmsg, 'color:red');
    if (data.errors) {
      console.log('\terrors: ', data.errors);
      data.errors.forEach((error, i) => {
        console.log('\terror_' + i + ': ', error);
      });
    }
    console.log('\tressponse: ', response);
    console.log(
      '----------------------------------------------------------------------------------------------------------------------------'
    );
  }
  let data =
    err.response && err.response.data && err.response.data.code
      ? err.response.data
      : {
          code: 500,
          message: 'error.server_error',
        };
  return Promise.reject(data);
};

export const handleApiSucess = (result) => {
  if (showMessage) {
    console.log(
      '\t%c<<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---  <<---',
      'background:green; color:white'
    );
    console.log('\turl: ' + result.data.url);
    console.log('\tstatus: %c' + result.status, 'color: green');
    console.log('\tstatusText: ' + result.statusText);
    if (result.data) console.log('\tdata: ', result.data);
    console.log('Result is: ', result);
    console.log(
      '----------------------------------------------------------------------------------------------------------------------------'
    );
  }
  return result.data;
};

export const getRequestHeaders = (auth, defaultHeaders) => () => ({
  headers: {
    ...auth.getAuthHeader(),
    ...defaultHeaders,
  },
});



// WEBPACK FOOTER //
// src/lib/api/util.api.js